<div class="mbm-message" role="status">
  <p class="mbm-message-text">{{ messageKey() | translate }}</p>
</div>
